//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import pricing from '~/mixins/pricing';
import cms from '~/mixins/cms';

export default {
  cmsId: 'home',
  name: 'cabinet-index',
  platforms: ['CABINET'],
  mixins: [pricing, cms],
  access: '*',
  asyncData ({ store, redirect }) {
    if (store.getters.isUser) redirect('/pricing');
  },
  computed: {
    title () {
      return this.$t(`cabinet.title`);
    },
    tabs () {
      return [
        {
          value: 'shipment',
          title: this.$t(
            `cabinet.tabs.${this.isMobile ? 'shipmentShort' : 'shipment'}`
          ),
        },
        {
          value: 'status',
          title: this.$t(
            `cabinet.tabs.${this.isMobile ? 'statusShort' : 'status'}`
          ),
        },
      ];
    },
    activeTab () {
      return this.$route.query.tab === 'status' ? 'status' : 'shipment';
    },
    correspondenceTabTitle () {
      const key = this.isMobile ? 'correspondenceShort' : 'correspondence';
      return this.$t(`cabinet.tabs.${key}`);
    },
  },
  created () {
    if (this.isWidget && this.$store.getters.isUser) this.$router.push('/pricing');
  },
  methods: {
    changeTab (tab) {
      const query = { ...this.$route.query };
      if (tab === 'shipment') delete query.tab;
      else query.tab = tab;

      if (tab === this.activeTab) return;
      this.$router.replace({ query });
    },
    search () {
      const errors = this.validate();
      if (errors) return Promise.resolve();
      this.resetRaids();
      return this.$router.push({
        name: 'pricing-id',
        params: { id: this.request.pricingQuery },
      });
    },
  },
};
